App.LogisticsCenter = DS.Model.extend
  name: DS.attr 'string'
